import React from "react";
import { languages } from "../../constants/languages";
import schedulePicture from "../../img/schema.png";
import Typography from "@material-ui/core/Typography";
import EditFieldContainer from "../../containers/schedule/EditFieldContainer";

const NoScheduleMessage = (props) => (
  <div
    style={{
      width: "95%",
      textAlign: "center",
      marginBottom: 20,
      whiteSpace: "normal",
    }}
  >
    <div style={{ maxWidth: 700, display: "inline-block" }}>
      <img
        src={schedulePicture}
        alt=""
        style={{ height: 100, margin: "0 0 5px 0" }}
      />
      <Typography variant="h6">
        {props.multipleLocations
          ? languages.schedule.noScheduleMessageTitleLocation
          : languages.schedule.noScheduleMessageTitle}
      </Typography>
      <Typography variant="subtitle1" style={{ fontSize: 17 }}>
        {languages.schedule.noScheduleMessageDescription}
      </Typography>
      <div style={{ marginTop: 10 }}>
        <EditFieldContainer
          tournament={props.tournament}
          first={true}
          selectedSportPark={props.selectedSportPark}
          selectedDay={props.selectedDay}
          tournamentStatus={props.tournamentStatus}
          userStatus={props.userStatus}
          user={props.user}
          toggleUpgradeDialog={props.toggleUpgradeDialog}
        />
      </div>
    </div>
  </div>
);

export default NoScheduleMessage;
